module.exports = __webpack_public_path__ + "cea7ff39.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/4k-640.mp4
// module id = 1211
// module chunks = 1 3 4